import React from 'react';

import styles from './index.module.scss';

export const GridToggle = ({ onClick, children }: { onClick: () => void; children: React.ReactNode }) => {
	return (
		<button
			onClick={onClick}
			disabled={false}
			className={`${styles.wrapper} px-[12px] py-[10px] bg-[#ffffff] border-none md:border-[#edf2f7] rounded-[9px] shadow-sm md:shadow-none`}
		>
			{children}
		</button>
	);
};
